import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useTypedMatches } from '@fortem-monorepo/react-spa';
export const Breadcrumbs = () => {
    const { matches } = useTypedMatches();
    const typedMatches = matches
        .filter((match) => match?.handle?.title)
        .map((match) => match.handle.title);
    return (_jsx("div", { className: 'flex items-center gap-2', children: typedMatches.length > 0 &&
            typedMatches.map((match, index) => {
                const isLast = index === typedMatches.length - 1;
                return (_jsxs(React.Fragment, { children: [_jsx("span", { className: 'text-2xl font-semibold text-primary opacity-30 tracking-wide uppercase', children: match }), !isLast && _jsx(ChevronRight, { size: 20, className: 'opacity-30' })] }, index));
            }) }));
};
